import { IEmailPayload } from './email-interface';
import requestInstance from '../../utils/instance-utils';

export const sendPatientEducationEmail = (
    payload: IEmailPayload,
    isWhitelisted: boolean
) =>
    requestInstance.post('email/', payload, {
        headers: { 'X-Is-Whitelisted': String(isWhitelisted) },
    });
